import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RetryFailedCapacityPlanSolvesMutationVariables = Types.Exact<{
  input: Types.RetryFailedCapacityPlanSolvesInput;
}>;


export type RetryFailedCapacityPlanSolvesMutation = { __typename?: 'Mutation', retryFailedCapacityPlanSolves: { __typename?: 'RetryFailedCapacityPlanSolvesPayload', capacityPlanRun?: { __typename?: 'CapacityPlanRun', id: any, status: Types.CapacityPlanRunStatus, solveProgress: { __typename?: 'CapacityPlanSolveProgress', total: number, queued: number, computing: number, computed: number, failed: number } } | null, errors?: Array<{ __typename?: 'CapacityPlanUserError', code: Types.CapacityPlanErrorCode, message: string, runId?: any | null }> | null } };


export const RetryFailedCapacityPlanSolvesDocument = gql`
    mutation RetryFailedCapacityPlanSolves($input: RetryFailedCapacityPlanSolvesInput!) {
  retryFailedCapacityPlanSolves(input: $input) {
    capacityPlanRun {
      id
      status
      solveProgress {
        total
        queued
        computing
        computed
        failed
      }
    }
    errors {
      ... on CapacityPlanUserError {
        code
        message
        runId
      }
    }
  }
}
    `;
export type RetryFailedCapacityPlanSolvesMutationFn = Apollo.MutationFunction<RetryFailedCapacityPlanSolvesMutation, RetryFailedCapacityPlanSolvesMutationVariables>;

/**
 * __useRetryFailedCapacityPlanSolvesMutation__
 *
 * To run a mutation, you first call `useRetryFailedCapacityPlanSolvesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryFailedCapacityPlanSolvesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryFailedCapacityPlanSolvesMutation, { data, loading, error }] = useRetryFailedCapacityPlanSolvesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRetryFailedCapacityPlanSolvesMutation(baseOptions?: Apollo.MutationHookOptions<RetryFailedCapacityPlanSolvesMutation, RetryFailedCapacityPlanSolvesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryFailedCapacityPlanSolvesMutation, RetryFailedCapacityPlanSolvesMutationVariables>(RetryFailedCapacityPlanSolvesDocument, options);
      }
export type RetryFailedCapacityPlanSolvesMutationHookResult = ReturnType<typeof useRetryFailedCapacityPlanSolvesMutation>;
export type RetryFailedCapacityPlanSolvesMutationResult = Apollo.MutationResult<RetryFailedCapacityPlanSolvesMutation>;
export type RetryFailedCapacityPlanSolvesMutationOptions = Apollo.BaseMutationOptions<RetryFailedCapacityPlanSolvesMutation, RetryFailedCapacityPlanSolvesMutationVariables>;